import ProjectAPIError from "@/api/error/ProjectAPIError";

export default class ProjectAPIUnauthorizedError extends ProjectAPIError {
  get httpErrorMessage() {
    return "로그인 후 이용하시기 바랍니다.";
  }
}
